<select [ngModel]="selectedLanguage" id="type" name="type" class="form-control language-picker" (change)="navigateToLanguage($event)">
  <option [value]="lang.link" *ngFor="let lang of languages">
    {{ lang.name }}
  </option>
</select>
